/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";

export const protobufPackage = "";

export enum HeadphoneState {
  INVALID = 0,
  NO_HEADPHONES = 1,
  WIRED_HEADPHONES = 2,
  BLUETOOTH_HEADPHONES = 3,
  NO_HEADPHONES_AEC = 4,
  UNRECOGNIZED = -1,
}

export function headphoneStateFromJSON(object: any): HeadphoneState {
  switch (object) {
    case 0:
    case "INVALID":
      return HeadphoneState.INVALID;
    case 1:
    case "NO_HEADPHONES":
      return HeadphoneState.NO_HEADPHONES;
    case 2:
    case "WIRED_HEADPHONES":
      return HeadphoneState.WIRED_HEADPHONES;
    case 3:
    case "BLUETOOTH_HEADPHONES":
      return HeadphoneState.BLUETOOTH_HEADPHONES;
    case 4:
    case "NO_HEADPHONES_AEC":
      return HeadphoneState.NO_HEADPHONES_AEC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return HeadphoneState.UNRECOGNIZED;
  }
}

export function headphoneStateToJSON(object: HeadphoneState): string {
  switch (object) {
    case HeadphoneState.INVALID:
      return "INVALID";
    case HeadphoneState.NO_HEADPHONES:
      return "NO_HEADPHONES";
    case HeadphoneState.WIRED_HEADPHONES:
      return "WIRED_HEADPHONES";
    case HeadphoneState.BLUETOOTH_HEADPHONES:
      return "BLUETOOTH_HEADPHONES";
    case HeadphoneState.NO_HEADPHONES_AEC:
      return "NO_HEADPHONES_AEC";
    case HeadphoneState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum VibeType {
  NORMAL = 0,
  MAGIC = 1,
  SLOW_REVERB = 2,
  CHARGED_UP = 3,
  T_PAIN = 4,
  ARIANA = 5,
  KHALED = 6,
  SLOW = 7,
  SPEED = 8,
  HAPPY = 9,
  BORED = 10,
  VINTAGE = 11,
  MP3 = 12,
  CASSETTE = 13,
  UNDERWATER = 14,
  SPACEY = 15,
  UBER = 16,
  UNRECOGNIZED = -1,
}

export function vibeTypeFromJSON(object: any): VibeType {
  switch (object) {
    case 0:
    case "NORMAL":
      return VibeType.NORMAL;
    case 1:
    case "MAGIC":
      return VibeType.MAGIC;
    case 2:
    case "SLOW_REVERB":
      return VibeType.SLOW_REVERB;
    case 3:
    case "CHARGED_UP":
      return VibeType.CHARGED_UP;
    case 4:
    case "T_PAIN":
      return VibeType.T_PAIN;
    case 5:
    case "ARIANA":
      return VibeType.ARIANA;
    case 6:
    case "KHALED":
      return VibeType.KHALED;
    case 7:
    case "SLOW":
      return VibeType.SLOW;
    case 8:
    case "SPEED":
      return VibeType.SPEED;
    case 9:
    case "HAPPY":
      return VibeType.HAPPY;
    case 10:
    case "BORED":
      return VibeType.BORED;
    case 11:
    case "VINTAGE":
      return VibeType.VINTAGE;
    case 12:
    case "MP3":
      return VibeType.MP3;
    case 13:
    case "CASSETTE":
      return VibeType.CASSETTE;
    case 14:
    case "UNDERWATER":
      return VibeType.UNDERWATER;
    case 15:
    case "SPACEY":
      return VibeType.SPACEY;
    case 16:
    case "UBER":
      return VibeType.UBER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return VibeType.UNRECOGNIZED;
  }
}

export function vibeTypeToJSON(object: VibeType): string {
  switch (object) {
    case VibeType.NORMAL:
      return "NORMAL";
    case VibeType.MAGIC:
      return "MAGIC";
    case VibeType.SLOW_REVERB:
      return "SLOW_REVERB";
    case VibeType.CHARGED_UP:
      return "CHARGED_UP";
    case VibeType.T_PAIN:
      return "T_PAIN";
    case VibeType.ARIANA:
      return "ARIANA";
    case VibeType.KHALED:
      return "KHALED";
    case VibeType.SLOW:
      return "SLOW";
    case VibeType.SPEED:
      return "SPEED";
    case VibeType.HAPPY:
      return "HAPPY";
    case VibeType.BORED:
      return "BORED";
    case VibeType.VINTAGE:
      return "VINTAGE";
    case VibeType.MP3:
      return "MP3";
    case VibeType.CASSETTE:
      return "CASSETTE";
    case VibeType.UNDERWATER:
      return "UNDERWATER";
    case VibeType.SPACEY:
      return "SPACEY";
    case VibeType.UBER:
      return "UBER";
    case VibeType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum EngineTweaks {
  ZPLANE_ENABLED = 0,
  AUTOTUNE_DEMOS_ENABLED = 1,
  ZPLANE_VOICE_FILTER_SWAPS = 2,
  USE_AUTOTALENT = 3,
  USE_LEAF_AUTOTUNE = 4,
  TRACK_BASED_EDITING = 5,
  INSTRUMENT_FILTER = 6,
  SPECTRAL_SIDECHAIN = 7,
  MAGIC_VIBE_GAIN_BOOST = 8,
  MESSAGE_MANAGER_THREAD = 9,
  USE_MULTISAMPLER = 11,
  USE_FORMANTSHIFTER = 12,
  COVERS_AI_MODE = 13,
  UNRECOGNIZED = -1,
}

export function engineTweaksFromJSON(object: any): EngineTweaks {
  switch (object) {
    case 0:
    case "ZPLANE_ENABLED":
      return EngineTweaks.ZPLANE_ENABLED;
    case 1:
    case "AUTOTUNE_DEMOS_ENABLED":
      return EngineTweaks.AUTOTUNE_DEMOS_ENABLED;
    case 2:
    case "ZPLANE_VOICE_FILTER_SWAPS":
      return EngineTweaks.ZPLANE_VOICE_FILTER_SWAPS;
    case 3:
    case "USE_AUTOTALENT":
      return EngineTweaks.USE_AUTOTALENT;
    case 4:
    case "USE_LEAF_AUTOTUNE":
      return EngineTweaks.USE_LEAF_AUTOTUNE;
    case 5:
    case "TRACK_BASED_EDITING":
      return EngineTweaks.TRACK_BASED_EDITING;
    case 6:
    case "INSTRUMENT_FILTER":
      return EngineTweaks.INSTRUMENT_FILTER;
    case 7:
    case "SPECTRAL_SIDECHAIN":
      return EngineTweaks.SPECTRAL_SIDECHAIN;
    case 8:
    case "MAGIC_VIBE_GAIN_BOOST":
      return EngineTweaks.MAGIC_VIBE_GAIN_BOOST;
    case 9:
    case "MESSAGE_MANAGER_THREAD":
      return EngineTweaks.MESSAGE_MANAGER_THREAD;
    case 11:
    case "USE_MULTISAMPLER":
      return EngineTweaks.USE_MULTISAMPLER;
    case 12:
    case "USE_FORMANTSHIFTER":
      return EngineTweaks.USE_FORMANTSHIFTER;
    case 13:
    case "COVERS_AI_MODE":
      return EngineTweaks.COVERS_AI_MODE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EngineTweaks.UNRECOGNIZED;
  }
}

export function engineTweaksToJSON(object: EngineTweaks): string {
  switch (object) {
    case EngineTweaks.ZPLANE_ENABLED:
      return "ZPLANE_ENABLED";
    case EngineTweaks.AUTOTUNE_DEMOS_ENABLED:
      return "AUTOTUNE_DEMOS_ENABLED";
    case EngineTweaks.ZPLANE_VOICE_FILTER_SWAPS:
      return "ZPLANE_VOICE_FILTER_SWAPS";
    case EngineTweaks.USE_AUTOTALENT:
      return "USE_AUTOTALENT";
    case EngineTweaks.USE_LEAF_AUTOTUNE:
      return "USE_LEAF_AUTOTUNE";
    case EngineTweaks.TRACK_BASED_EDITING:
      return "TRACK_BASED_EDITING";
    case EngineTweaks.INSTRUMENT_FILTER:
      return "INSTRUMENT_FILTER";
    case EngineTweaks.SPECTRAL_SIDECHAIN:
      return "SPECTRAL_SIDECHAIN";
    case EngineTweaks.MAGIC_VIBE_GAIN_BOOST:
      return "MAGIC_VIBE_GAIN_BOOST";
    case EngineTweaks.MESSAGE_MANAGER_THREAD:
      return "MESSAGE_MANAGER_THREAD";
    case EngineTweaks.USE_MULTISAMPLER:
      return "USE_MULTISAMPLER";
    case EngineTweaks.USE_FORMANTSHIFTER:
      return "USE_FORMANTSHIFTER";
    case EngineTweaks.COVERS_AI_MODE:
      return "COVERS_AI_MODE";
    case EngineTweaks.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * To regenerate pb.swift files, cd into the mayk/proto directory and run:
 * ./update_proto.sh
 */
export interface AudioProject {
  tracks: Track[];
  duration: number;
  frameRate: number;
  modifiers: ProjectModifier[];
  startTimeDeprecated: number;
  endTimeDeprecated: number;
}

export interface ChordProg {
  chords: number[];
}

export interface ProjectModifier {
  vibeType?: VibeType | undefined;
  volume?: number | undefined;
  speed?: number | undefined;
  pitch?: number | undefined;
  keyAndScale?: KeyAndScale | undefined;
  bpm?: number | undefined;
  pan?: number | undefined;
  startTime?: number | undefined;
  endTime?: number | undefined;
  vibeSettings?: VibeSettings | undefined;
  beatStartInSecs?: number | undefined;
  chords?: ChordProg | undefined;
}

export interface Track {
  id: string;
  kind: Track_Kind;
  clips: Clip[];
  name: string;
  sampler: Sampler | undefined;
  modifiers: TrackModifier[];
}

export enum Track_Kind {
  INVALID = 0,
  VOICE = 1,
  BEAT = 2,
  SOUND_FX = 3,
  AMBIENCE = 4,
  SECONDARY_BEAT = 5,
  UNRECOGNIZED = -1,
}

export function track_KindFromJSON(object: any): Track_Kind {
  switch (object) {
    case 0:
    case "INVALID":
      return Track_Kind.INVALID;
    case 1:
    case "VOICE":
      return Track_Kind.VOICE;
    case 2:
    case "BEAT":
      return Track_Kind.BEAT;
    case 3:
    case "SOUND_FX":
      return Track_Kind.SOUND_FX;
    case 4:
    case "AMBIENCE":
      return Track_Kind.AMBIENCE;
    case 5:
    case "SECONDARY_BEAT":
      return Track_Kind.SECONDARY_BEAT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Track_Kind.UNRECOGNIZED;
  }
}

export function track_KindToJSON(object: Track_Kind): string {
  switch (object) {
    case Track_Kind.INVALID:
      return "INVALID";
    case Track_Kind.VOICE:
      return "VOICE";
    case Track_Kind.BEAT:
      return "BEAT";
    case Track_Kind.SOUND_FX:
      return "SOUND_FX";
    case Track_Kind.AMBIENCE:
      return "AMBIENCE";
    case Track_Kind.SECONDARY_BEAT:
      return "SECONDARY_BEAT";
    case Track_Kind.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface TrackModifier {
  voiceFx?: VoiceFx | undefined;
  volume?: number | undefined;
  pitch?: number | undefined;
  rate?: number | undefined;
  pan?: number | undefined;
}

export interface Clip {
  id: string;
  /** URL of the clip audio file. */
  url: string;
  /** Clip kind */
  kind: Clip_Kind;
  /** Where to start playback in the audio file. */
  startTrim: number;
  /** The amount of time trimmed off the end of the file. end = duration - endTrim */
  endTrim: number;
  /** Where in the timeline this clip should start playing */
  startOffset: number;
  /** The original duration of the audio file. */
  duration: number;
  /** Clip modifiers */
  modifiers: ClipModifier[];
  /** Clip name. */
  name: string;
  attributionInfo: ClipAttributionInfo | undefined;
  recordedHeadphoneState: HeadphoneState;
  /** Remote URL if already uploaded. */
  remotePath: string;
  /** Original URL if URL is modified from an existing clip (e.g. UberDuck) */
  originalURL: string;
  externalProcessedId: string;
}

export enum Clip_Kind {
  INVALID = 0,
  VOICE = 1,
  BEAT = 2,
  SOUND_FX = 3,
  AMBIENCE = 4,
  SECONDARY_BEAT = 5,
  UNRECOGNIZED = -1,
}

export function clip_KindFromJSON(object: any): Clip_Kind {
  switch (object) {
    case 0:
    case "INVALID":
      return Clip_Kind.INVALID;
    case 1:
    case "VOICE":
      return Clip_Kind.VOICE;
    case 2:
    case "BEAT":
      return Clip_Kind.BEAT;
    case 3:
    case "SOUND_FX":
      return Clip_Kind.SOUND_FX;
    case 4:
    case "AMBIENCE":
      return Clip_Kind.AMBIENCE;
    case 5:
    case "SECONDARY_BEAT":
      return Clip_Kind.SECONDARY_BEAT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Clip_Kind.UNRECOGNIZED;
  }
}

export function clip_KindToJSON(object: Clip_Kind): string {
  switch (object) {
    case Clip_Kind.INVALID:
      return "INVALID";
    case Clip_Kind.VOICE:
      return "VOICE";
    case Clip_Kind.BEAT:
      return "BEAT";
    case Clip_Kind.SOUND_FX:
      return "SOUND_FX";
    case Clip_Kind.AMBIENCE:
      return "AMBIENCE";
    case Clip_Kind.SECONDARY_BEAT:
      return "SECONDARY_BEAT";
    case Clip_Kind.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface ClipAttributionInfo {
  /** NOTE: If the creator type is producer, this is a producer ID. */
  creatorId: string;
  creatorType: ClipAttributionInfo_CreatorType;
  /** TODO(Jeremy): Not yet populated. */
  editorIds: string[];
}

export enum ClipAttributionInfo_CreatorType {
  INVALID = 0,
  USER = 1,
  PRODUCER = 2,
  MAYK = 3,
  UNRECOGNIZED = -1,
}

export function clipAttributionInfo_CreatorTypeFromJSON(object: any): ClipAttributionInfo_CreatorType {
  switch (object) {
    case 0:
    case "INVALID":
      return ClipAttributionInfo_CreatorType.INVALID;
    case 1:
    case "USER":
      return ClipAttributionInfo_CreatorType.USER;
    case 2:
    case "PRODUCER":
      return ClipAttributionInfo_CreatorType.PRODUCER;
    case 3:
    case "MAYK":
      return ClipAttributionInfo_CreatorType.MAYK;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ClipAttributionInfo_CreatorType.UNRECOGNIZED;
  }
}

export function clipAttributionInfo_CreatorTypeToJSON(object: ClipAttributionInfo_CreatorType): string {
  switch (object) {
    case ClipAttributionInfo_CreatorType.INVALID:
      return "INVALID";
    case ClipAttributionInfo_CreatorType.USER:
      return "USER";
    case ClipAttributionInfo_CreatorType.PRODUCER:
      return "PRODUCER";
    case ClipAttributionInfo_CreatorType.MAYK:
      return "MAYK";
    case ClipAttributionInfo_CreatorType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface ClipModifier {
  voiceFx?: VoiceFx | undefined;
  vibe?: VibeType | undefined;
  volume?: number | undefined;
  pitch?: number | undefined;
  rate?: number | undefined;
  denoised?:
    | boolean
    | undefined;
  /** L/R panning of this clip from -1 (left) to 1 (right). 0 is default. */
  pan?: number | undefined;
}

export interface VoiceFx {
  type: VoiceFx_VoiceFxType;
  params: { [key: string]: number };
  intensity: number;
}

export enum VoiceFx_VoiceFxType {
  NONE = 0,
  STAR = 1,
  CHOIR = 2,
  ARIANA = 3,
  KHALED = 4,
  RADIO = 5,
  ECHO = 6,
  DEEP = 7,
  HARMONY = 8,
  HELIUM = 9,
  PSYCHEDELIC = 10,
  VOCODER = 12,
  POP = 13,
  GAMEBOY = 14,
  CHURCH = 16,
  MAGIC = 17,
  DISTORTION = 18,
  WARBLE = 19,
  SYNTHXX = 20,
  PRO = 21,
  CUSTOM = 22,
  DOUBLER = 27,
  HYPERPOP = 29,
  ROBOT = 30,
  LEAFAUTOTUNE = 32,
  HARMONIZER = 33,
  INSTRUMENT = 34,
  SAMPLER_CHOIR = 35,
  SAMPLER_STRINGS = 36,
  SAMPLER_PIANO = 37,
  MALE = 38,
  FEMALE = 39,
  UNRECOGNIZED = -1,
}

export function voiceFx_VoiceFxTypeFromJSON(object: any): VoiceFx_VoiceFxType {
  switch (object) {
    case 0:
    case "NONE":
      return VoiceFx_VoiceFxType.NONE;
    case 1:
    case "STAR":
      return VoiceFx_VoiceFxType.STAR;
    case 2:
    case "CHOIR":
      return VoiceFx_VoiceFxType.CHOIR;
    case 3:
    case "ARIANA":
      return VoiceFx_VoiceFxType.ARIANA;
    case 4:
    case "KHALED":
      return VoiceFx_VoiceFxType.KHALED;
    case 5:
    case "RADIO":
      return VoiceFx_VoiceFxType.RADIO;
    case 6:
    case "ECHO":
      return VoiceFx_VoiceFxType.ECHO;
    case 7:
    case "DEEP":
      return VoiceFx_VoiceFxType.DEEP;
    case 8:
    case "HARMONY":
      return VoiceFx_VoiceFxType.HARMONY;
    case 9:
    case "HELIUM":
      return VoiceFx_VoiceFxType.HELIUM;
    case 10:
    case "PSYCHEDELIC":
      return VoiceFx_VoiceFxType.PSYCHEDELIC;
    case 12:
    case "VOCODER":
      return VoiceFx_VoiceFxType.VOCODER;
    case 13:
    case "POP":
      return VoiceFx_VoiceFxType.POP;
    case 14:
    case "GAMEBOY":
      return VoiceFx_VoiceFxType.GAMEBOY;
    case 16:
    case "CHURCH":
      return VoiceFx_VoiceFxType.CHURCH;
    case 17:
    case "MAGIC":
      return VoiceFx_VoiceFxType.MAGIC;
    case 18:
    case "DISTORTION":
      return VoiceFx_VoiceFxType.DISTORTION;
    case 19:
    case "WARBLE":
      return VoiceFx_VoiceFxType.WARBLE;
    case 20:
    case "SYNTHXX":
      return VoiceFx_VoiceFxType.SYNTHXX;
    case 21:
    case "PRO":
      return VoiceFx_VoiceFxType.PRO;
    case 22:
    case "CUSTOM":
      return VoiceFx_VoiceFxType.CUSTOM;
    case 27:
    case "DOUBLER":
      return VoiceFx_VoiceFxType.DOUBLER;
    case 29:
    case "HYPERPOP":
      return VoiceFx_VoiceFxType.HYPERPOP;
    case 30:
    case "ROBOT":
      return VoiceFx_VoiceFxType.ROBOT;
    case 32:
    case "LEAFAUTOTUNE":
      return VoiceFx_VoiceFxType.LEAFAUTOTUNE;
    case 33:
    case "HARMONIZER":
      return VoiceFx_VoiceFxType.HARMONIZER;
    case 34:
    case "INSTRUMENT":
      return VoiceFx_VoiceFxType.INSTRUMENT;
    case 35:
    case "SAMPLER_CHOIR":
      return VoiceFx_VoiceFxType.SAMPLER_CHOIR;
    case 36:
    case "SAMPLER_STRINGS":
      return VoiceFx_VoiceFxType.SAMPLER_STRINGS;
    case 37:
    case "SAMPLER_PIANO":
      return VoiceFx_VoiceFxType.SAMPLER_PIANO;
    case 38:
    case "MALE":
      return VoiceFx_VoiceFxType.MALE;
    case 39:
    case "FEMALE":
      return VoiceFx_VoiceFxType.FEMALE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return VoiceFx_VoiceFxType.UNRECOGNIZED;
  }
}

export function voiceFx_VoiceFxTypeToJSON(object: VoiceFx_VoiceFxType): string {
  switch (object) {
    case VoiceFx_VoiceFxType.NONE:
      return "NONE";
    case VoiceFx_VoiceFxType.STAR:
      return "STAR";
    case VoiceFx_VoiceFxType.CHOIR:
      return "CHOIR";
    case VoiceFx_VoiceFxType.ARIANA:
      return "ARIANA";
    case VoiceFx_VoiceFxType.KHALED:
      return "KHALED";
    case VoiceFx_VoiceFxType.RADIO:
      return "RADIO";
    case VoiceFx_VoiceFxType.ECHO:
      return "ECHO";
    case VoiceFx_VoiceFxType.DEEP:
      return "DEEP";
    case VoiceFx_VoiceFxType.HARMONY:
      return "HARMONY";
    case VoiceFx_VoiceFxType.HELIUM:
      return "HELIUM";
    case VoiceFx_VoiceFxType.PSYCHEDELIC:
      return "PSYCHEDELIC";
    case VoiceFx_VoiceFxType.VOCODER:
      return "VOCODER";
    case VoiceFx_VoiceFxType.POP:
      return "POP";
    case VoiceFx_VoiceFxType.GAMEBOY:
      return "GAMEBOY";
    case VoiceFx_VoiceFxType.CHURCH:
      return "CHURCH";
    case VoiceFx_VoiceFxType.MAGIC:
      return "MAGIC";
    case VoiceFx_VoiceFxType.DISTORTION:
      return "DISTORTION";
    case VoiceFx_VoiceFxType.WARBLE:
      return "WARBLE";
    case VoiceFx_VoiceFxType.SYNTHXX:
      return "SYNTHXX";
    case VoiceFx_VoiceFxType.PRO:
      return "PRO";
    case VoiceFx_VoiceFxType.CUSTOM:
      return "CUSTOM";
    case VoiceFx_VoiceFxType.DOUBLER:
      return "DOUBLER";
    case VoiceFx_VoiceFxType.HYPERPOP:
      return "HYPERPOP";
    case VoiceFx_VoiceFxType.ROBOT:
      return "ROBOT";
    case VoiceFx_VoiceFxType.LEAFAUTOTUNE:
      return "LEAFAUTOTUNE";
    case VoiceFx_VoiceFxType.HARMONIZER:
      return "HARMONIZER";
    case VoiceFx_VoiceFxType.INSTRUMENT:
      return "INSTRUMENT";
    case VoiceFx_VoiceFxType.SAMPLER_CHOIR:
      return "SAMPLER_CHOIR";
    case VoiceFx_VoiceFxType.SAMPLER_STRINGS:
      return "SAMPLER_STRINGS";
    case VoiceFx_VoiceFxType.SAMPLER_PIANO:
      return "SAMPLER_PIANO";
    case VoiceFx_VoiceFxType.MALE:
      return "MALE";
    case VoiceFx_VoiceFxType.FEMALE:
      return "FEMALE";
    case VoiceFx_VoiceFxType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface VoiceFx_ParamsEntry {
  key: string;
  value: number;
}

export interface VibeSettings {
  intensity: number;
}

export interface Sampler {
  id: string;
  samples: { [key: string]: Sample };
}

export interface Sampler_SamplesEntry {
  key: string;
  value: Sample | undefined;
}

export interface Sample {
  id: string;
  filePath: string;
  startTimeInFile: number;
  duration: number;
  remotePath: string;
  midiNote: number;
}

export interface KeyAndScale {
  key: KeyAndScale_Key;
  scale: KeyAndScale_Scale;
}

export enum KeyAndScale_Key {
  C = 0,
  Db = 1,
  D = 2,
  Eb = 3,
  E = 4,
  F = 5,
  Gb = 6,
  G = 7,
  Ab = 8,
  A = 9,
  Bb = 10,
  B = 11,
  UNRECOGNIZED = -1,
}

export function keyAndScale_KeyFromJSON(object: any): KeyAndScale_Key {
  switch (object) {
    case 0:
    case "C":
      return KeyAndScale_Key.C;
    case 1:
    case "Db":
      return KeyAndScale_Key.Db;
    case 2:
    case "D":
      return KeyAndScale_Key.D;
    case 3:
    case "Eb":
      return KeyAndScale_Key.Eb;
    case 4:
    case "E":
      return KeyAndScale_Key.E;
    case 5:
    case "F":
      return KeyAndScale_Key.F;
    case 6:
    case "Gb":
      return KeyAndScale_Key.Gb;
    case 7:
    case "G":
      return KeyAndScale_Key.G;
    case 8:
    case "Ab":
      return KeyAndScale_Key.Ab;
    case 9:
    case "A":
      return KeyAndScale_Key.A;
    case 10:
    case "Bb":
      return KeyAndScale_Key.Bb;
    case 11:
    case "B":
      return KeyAndScale_Key.B;
    case -1:
    case "UNRECOGNIZED":
    default:
      return KeyAndScale_Key.UNRECOGNIZED;
  }
}

export function keyAndScale_KeyToJSON(object: KeyAndScale_Key): string {
  switch (object) {
    case KeyAndScale_Key.C:
      return "C";
    case KeyAndScale_Key.Db:
      return "Db";
    case KeyAndScale_Key.D:
      return "D";
    case KeyAndScale_Key.Eb:
      return "Eb";
    case KeyAndScale_Key.E:
      return "E";
    case KeyAndScale_Key.F:
      return "F";
    case KeyAndScale_Key.Gb:
      return "Gb";
    case KeyAndScale_Key.G:
      return "G";
    case KeyAndScale_Key.Ab:
      return "Ab";
    case KeyAndScale_Key.A:
      return "A";
    case KeyAndScale_Key.Bb:
      return "Bb";
    case KeyAndScale_Key.B:
      return "B";
    case KeyAndScale_Key.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum KeyAndScale_Scale {
  MAJOR = 0,
  MINOR = 1,
  PENTATONIC = 2,
  CHROMATIC = 3,
  UNRECOGNIZED = -1,
}

export function keyAndScale_ScaleFromJSON(object: any): KeyAndScale_Scale {
  switch (object) {
    case 0:
    case "MAJOR":
      return KeyAndScale_Scale.MAJOR;
    case 1:
    case "MINOR":
      return KeyAndScale_Scale.MINOR;
    case 2:
    case "PENTATONIC":
      return KeyAndScale_Scale.PENTATONIC;
    case 3:
    case "CHROMATIC":
      return KeyAndScale_Scale.CHROMATIC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return KeyAndScale_Scale.UNRECOGNIZED;
  }
}

export function keyAndScale_ScaleToJSON(object: KeyAndScale_Scale): string {
  switch (object) {
    case KeyAndScale_Scale.MAJOR:
      return "MAJOR";
    case KeyAndScale_Scale.MINOR:
      return "MINOR";
    case KeyAndScale_Scale.PENTATONIC:
      return "PENTATONIC";
    case KeyAndScale_Scale.CHROMATIC:
      return "CHROMATIC";
    case KeyAndScale_Scale.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface EngineStats {
  sessionLengthMilliseconds: number;
  percentageSamplesClipped: number;
  currentCPULoad: number;
  currentRAMUsageGB: number;
}

function createBaseAudioProject(): AudioProject {
  return { tracks: [], duration: 0, frameRate: 0, modifiers: [], startTimeDeprecated: 0, endTimeDeprecated: 0 };
}

export const AudioProject = {
  encode(message: AudioProject, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.tracks) {
      Track.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.duration !== 0) {
      writer.uint32(17).double(message.duration);
    }
    if (message.frameRate !== 0) {
      writer.uint32(25).double(message.frameRate);
    }
    for (const v of message.modifiers) {
      ProjectModifier.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    if (message.startTimeDeprecated !== 0) {
      writer.uint32(41).double(message.startTimeDeprecated);
    }
    if (message.endTimeDeprecated !== 0) {
      writer.uint32(49).double(message.endTimeDeprecated);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AudioProject {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAudioProject();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tracks.push(Track.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }

          message.duration = reader.double();
          continue;
        case 3:
          if (tag !== 25) {
            break;
          }

          message.frameRate = reader.double();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.modifiers.push(ProjectModifier.decode(reader, reader.uint32()));
          continue;
        case 5:
          if (tag !== 41) {
            break;
          }

          message.startTimeDeprecated = reader.double();
          continue;
        case 6:
          if (tag !== 49) {
            break;
          }

          message.endTimeDeprecated = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AudioProject {
    return {
      tracks: globalThis.Array.isArray(object?.tracks) ? object.tracks.map((e: any) => Track.fromJSON(e)) : [],
      duration: isSet(object.duration) ? globalThis.Number(object.duration) : 0,
      frameRate: isSet(object.frameRate) ? globalThis.Number(object.frameRate) : 0,
      modifiers: globalThis.Array.isArray(object?.modifiers)
        ? object.modifiers.map((e: any) => ProjectModifier.fromJSON(e))
        : [],
      startTimeDeprecated: isSet(object.startTimeDeprecated) ? globalThis.Number(object.startTimeDeprecated) : 0,
      endTimeDeprecated: isSet(object.endTimeDeprecated) ? globalThis.Number(object.endTimeDeprecated) : 0,
    };
  },

  toJSON(message: AudioProject): unknown {
    const obj: any = {};
    if (message.tracks?.length) {
      obj.tracks = message.tracks.map((e) => Track.toJSON(e));
    }
    if (message.duration !== 0) {
      obj.duration = message.duration;
    }
    if (message.frameRate !== 0) {
      obj.frameRate = message.frameRate;
    }
    if (message.modifiers?.length) {
      obj.modifiers = message.modifiers.map((e) => ProjectModifier.toJSON(e));
    }
    if (message.startTimeDeprecated !== 0) {
      obj.startTimeDeprecated = message.startTimeDeprecated;
    }
    if (message.endTimeDeprecated !== 0) {
      obj.endTimeDeprecated = message.endTimeDeprecated;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AudioProject>, I>>(base?: I): AudioProject {
    return AudioProject.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AudioProject>, I>>(object: I): AudioProject {
    const message = createBaseAudioProject();
    message.tracks = object.tracks?.map((e) => Track.fromPartial(e)) || [];
    message.duration = object.duration ?? 0;
    message.frameRate = object.frameRate ?? 0;
    message.modifiers = object.modifiers?.map((e) => ProjectModifier.fromPartial(e)) || [];
    message.startTimeDeprecated = object.startTimeDeprecated ?? 0;
    message.endTimeDeprecated = object.endTimeDeprecated ?? 0;
    return message;
  },
};

function createBaseChordProg(): ChordProg {
  return { chords: [] };
}

export const ChordProg = {
  encode(message: ChordProg, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    writer.uint32(10).fork();
    for (const v of message.chords) {
      writer.int32(v);
    }
    writer.ldelim();
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ChordProg {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChordProg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag === 8) {
            message.chords.push(reader.int32());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.chords.push(reader.int32());
            }

            continue;
          }

          break;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChordProg {
    return {
      chords: globalThis.Array.isArray(object?.chords) ? object.chords.map((e: any) => globalThis.Number(e)) : [],
    };
  },

  toJSON(message: ChordProg): unknown {
    const obj: any = {};
    if (message.chords?.length) {
      obj.chords = message.chords.map((e) => Math.round(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChordProg>, I>>(base?: I): ChordProg {
    return ChordProg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChordProg>, I>>(object: I): ChordProg {
    const message = createBaseChordProg();
    message.chords = object.chords?.map((e) => e) || [];
    return message;
  },
};

function createBaseProjectModifier(): ProjectModifier {
  return {
    vibeType: undefined,
    volume: undefined,
    speed: undefined,
    pitch: undefined,
    keyAndScale: undefined,
    bpm: undefined,
    pan: undefined,
    startTime: undefined,
    endTime: undefined,
    vibeSettings: undefined,
    beatStartInSecs: undefined,
    chords: undefined,
  };
}

export const ProjectModifier = {
  encode(message: ProjectModifier, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.vibeType !== undefined) {
      writer.uint32(8).int32(message.vibeType);
    }
    if (message.volume !== undefined) {
      writer.uint32(21).float(message.volume);
    }
    if (message.speed !== undefined) {
      writer.uint32(29).float(message.speed);
    }
    if (message.pitch !== undefined) {
      writer.uint32(37).float(message.pitch);
    }
    if (message.keyAndScale !== undefined) {
      KeyAndScale.encode(message.keyAndScale, writer.uint32(42).fork()).ldelim();
    }
    if (message.bpm !== undefined) {
      writer.uint32(49).double(message.bpm);
    }
    if (message.pan !== undefined) {
      writer.uint32(61).float(message.pan);
    }
    if (message.startTime !== undefined) {
      writer.uint32(65).double(message.startTime);
    }
    if (message.endTime !== undefined) {
      writer.uint32(73).double(message.endTime);
    }
    if (message.vibeSettings !== undefined) {
      VibeSettings.encode(message.vibeSettings, writer.uint32(82).fork()).ldelim();
    }
    if (message.beatStartInSecs !== undefined) {
      writer.uint32(89).double(message.beatStartInSecs);
    }
    if (message.chords !== undefined) {
      ChordProg.encode(message.chords, writer.uint32(98).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ProjectModifier {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectModifier();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.vibeType = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.volume = reader.float();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.speed = reader.float();
          continue;
        case 4:
          if (tag !== 37) {
            break;
          }

          message.pitch = reader.float();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.keyAndScale = KeyAndScale.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 49) {
            break;
          }

          message.bpm = reader.double();
          continue;
        case 7:
          if (tag !== 61) {
            break;
          }

          message.pan = reader.float();
          continue;
        case 8:
          if (tag !== 65) {
            break;
          }

          message.startTime = reader.double();
          continue;
        case 9:
          if (tag !== 73) {
            break;
          }

          message.endTime = reader.double();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.vibeSettings = VibeSettings.decode(reader, reader.uint32());
          continue;
        case 11:
          if (tag !== 89) {
            break;
          }

          message.beatStartInSecs = reader.double();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.chords = ChordProg.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectModifier {
    return {
      vibeType: isSet(object.vibeType) ? vibeTypeFromJSON(object.vibeType) : undefined,
      volume: isSet(object.volume) ? globalThis.Number(object.volume) : undefined,
      speed: isSet(object.speed) ? globalThis.Number(object.speed) : undefined,
      pitch: isSet(object.pitch) ? globalThis.Number(object.pitch) : undefined,
      keyAndScale: isSet(object.keyAndScale) ? KeyAndScale.fromJSON(object.keyAndScale) : undefined,
      bpm: isSet(object.bpm) ? globalThis.Number(object.bpm) : undefined,
      pan: isSet(object.pan) ? globalThis.Number(object.pan) : undefined,
      startTime: isSet(object.startTime) ? globalThis.Number(object.startTime) : undefined,
      endTime: isSet(object.endTime) ? globalThis.Number(object.endTime) : undefined,
      vibeSettings: isSet(object.vibeSettings) ? VibeSettings.fromJSON(object.vibeSettings) : undefined,
      beatStartInSecs: isSet(object.beatStartInSecs) ? globalThis.Number(object.beatStartInSecs) : undefined,
      chords: isSet(object.chords) ? ChordProg.fromJSON(object.chords) : undefined,
    };
  },

  toJSON(message: ProjectModifier): unknown {
    const obj: any = {};
    if (message.vibeType !== undefined) {
      obj.vibeType = vibeTypeToJSON(message.vibeType);
    }
    if (message.volume !== undefined) {
      obj.volume = message.volume;
    }
    if (message.speed !== undefined) {
      obj.speed = message.speed;
    }
    if (message.pitch !== undefined) {
      obj.pitch = message.pitch;
    }
    if (message.keyAndScale !== undefined) {
      obj.keyAndScale = KeyAndScale.toJSON(message.keyAndScale);
    }
    if (message.bpm !== undefined) {
      obj.bpm = message.bpm;
    }
    if (message.pan !== undefined) {
      obj.pan = message.pan;
    }
    if (message.startTime !== undefined) {
      obj.startTime = message.startTime;
    }
    if (message.endTime !== undefined) {
      obj.endTime = message.endTime;
    }
    if (message.vibeSettings !== undefined) {
      obj.vibeSettings = VibeSettings.toJSON(message.vibeSettings);
    }
    if (message.beatStartInSecs !== undefined) {
      obj.beatStartInSecs = message.beatStartInSecs;
    }
    if (message.chords !== undefined) {
      obj.chords = ChordProg.toJSON(message.chords);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProjectModifier>, I>>(base?: I): ProjectModifier {
    return ProjectModifier.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProjectModifier>, I>>(object: I): ProjectModifier {
    const message = createBaseProjectModifier();
    message.vibeType = object.vibeType ?? undefined;
    message.volume = object.volume ?? undefined;
    message.speed = object.speed ?? undefined;
    message.pitch = object.pitch ?? undefined;
    message.keyAndScale = (object.keyAndScale !== undefined && object.keyAndScale !== null)
      ? KeyAndScale.fromPartial(object.keyAndScale)
      : undefined;
    message.bpm = object.bpm ?? undefined;
    message.pan = object.pan ?? undefined;
    message.startTime = object.startTime ?? undefined;
    message.endTime = object.endTime ?? undefined;
    message.vibeSettings = (object.vibeSettings !== undefined && object.vibeSettings !== null)
      ? VibeSettings.fromPartial(object.vibeSettings)
      : undefined;
    message.beatStartInSecs = object.beatStartInSecs ?? undefined;
    message.chords = (object.chords !== undefined && object.chords !== null)
      ? ChordProg.fromPartial(object.chords)
      : undefined;
    return message;
  },
};

function createBaseTrack(): Track {
  return { id: "", kind: 0, clips: [], name: "", sampler: undefined, modifiers: [] };
}

export const Track = {
  encode(message: Track, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.kind !== 0) {
      writer.uint32(16).int32(message.kind);
    }
    for (const v of message.clips) {
      Clip.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.sampler !== undefined) {
      Sampler.encode(message.sampler, writer.uint32(42).fork()).ldelim();
    }
    for (const v of message.modifiers) {
      TrackModifier.encode(v!, writer.uint32(50).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Track {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrack();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.clips.push(Clip.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.sampler = Sampler.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.modifiers.push(TrackModifier.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Track {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      kind: isSet(object.kind) ? track_KindFromJSON(object.kind) : 0,
      clips: globalThis.Array.isArray(object?.clips) ? object.clips.map((e: any) => Clip.fromJSON(e)) : [],
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      sampler: isSet(object.sampler) ? Sampler.fromJSON(object.sampler) : undefined,
      modifiers: globalThis.Array.isArray(object?.modifiers)
        ? object.modifiers.map((e: any) => TrackModifier.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Track): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.kind !== 0) {
      obj.kind = track_KindToJSON(message.kind);
    }
    if (message.clips?.length) {
      obj.clips = message.clips.map((e) => Clip.toJSON(e));
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.sampler !== undefined) {
      obj.sampler = Sampler.toJSON(message.sampler);
    }
    if (message.modifiers?.length) {
      obj.modifiers = message.modifiers.map((e) => TrackModifier.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Track>, I>>(base?: I): Track {
    return Track.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Track>, I>>(object: I): Track {
    const message = createBaseTrack();
    message.id = object.id ?? "";
    message.kind = object.kind ?? 0;
    message.clips = object.clips?.map((e) => Clip.fromPartial(e)) || [];
    message.name = object.name ?? "";
    message.sampler = (object.sampler !== undefined && object.sampler !== null)
      ? Sampler.fromPartial(object.sampler)
      : undefined;
    message.modifiers = object.modifiers?.map((e) => TrackModifier.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTrackModifier(): TrackModifier {
  return { voiceFx: undefined, volume: undefined, pitch: undefined, rate: undefined, pan: undefined };
}

export const TrackModifier = {
  encode(message: TrackModifier, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.voiceFx !== undefined) {
      VoiceFx.encode(message.voiceFx, writer.uint32(10).fork()).ldelim();
    }
    if (message.volume !== undefined) {
      writer.uint32(21).float(message.volume);
    }
    if (message.pitch !== undefined) {
      writer.uint32(29).float(message.pitch);
    }
    if (message.rate !== undefined) {
      writer.uint32(33).double(message.rate);
    }
    if (message.pan !== undefined) {
      writer.uint32(45).float(message.pan);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TrackModifier {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrackModifier();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.voiceFx = VoiceFx.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.volume = reader.float();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.pitch = reader.float();
          continue;
        case 4:
          if (tag !== 33) {
            break;
          }

          message.rate = reader.double();
          continue;
        case 5:
          if (tag !== 45) {
            break;
          }

          message.pan = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TrackModifier {
    return {
      voiceFx: isSet(object.voiceFx) ? VoiceFx.fromJSON(object.voiceFx) : undefined,
      volume: isSet(object.volume) ? globalThis.Number(object.volume) : undefined,
      pitch: isSet(object.pitch) ? globalThis.Number(object.pitch) : undefined,
      rate: isSet(object.rate) ? globalThis.Number(object.rate) : undefined,
      pan: isSet(object.pan) ? globalThis.Number(object.pan) : undefined,
    };
  },

  toJSON(message: TrackModifier): unknown {
    const obj: any = {};
    if (message.voiceFx !== undefined) {
      obj.voiceFx = VoiceFx.toJSON(message.voiceFx);
    }
    if (message.volume !== undefined) {
      obj.volume = message.volume;
    }
    if (message.pitch !== undefined) {
      obj.pitch = message.pitch;
    }
    if (message.rate !== undefined) {
      obj.rate = message.rate;
    }
    if (message.pan !== undefined) {
      obj.pan = message.pan;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TrackModifier>, I>>(base?: I): TrackModifier {
    return TrackModifier.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrackModifier>, I>>(object: I): TrackModifier {
    const message = createBaseTrackModifier();
    message.voiceFx = (object.voiceFx !== undefined && object.voiceFx !== null)
      ? VoiceFx.fromPartial(object.voiceFx)
      : undefined;
    message.volume = object.volume ?? undefined;
    message.pitch = object.pitch ?? undefined;
    message.rate = object.rate ?? undefined;
    message.pan = object.pan ?? undefined;
    return message;
  },
};

function createBaseClip(): Clip {
  return {
    id: "",
    url: "",
    kind: 0,
    startTrim: 0,
    endTrim: 0,
    startOffset: 0,
    duration: 0,
    modifiers: [],
    name: "",
    attributionInfo: undefined,
    recordedHeadphoneState: 0,
    remotePath: "",
    originalURL: "",
    externalProcessedId: "",
  };
}

export const Clip = {
  encode(message: Clip, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.url !== "") {
      writer.uint32(18).string(message.url);
    }
    if (message.kind !== 0) {
      writer.uint32(24).int32(message.kind);
    }
    if (message.startTrim !== 0) {
      writer.uint32(33).double(message.startTrim);
    }
    if (message.endTrim !== 0) {
      writer.uint32(41).double(message.endTrim);
    }
    if (message.startOffset !== 0) {
      writer.uint32(49).double(message.startOffset);
    }
    if (message.duration !== 0) {
      writer.uint32(57).double(message.duration);
    }
    for (const v of message.modifiers) {
      ClipModifier.encode(v!, writer.uint32(66).fork()).ldelim();
    }
    if (message.name !== "") {
      writer.uint32(74).string(message.name);
    }
    if (message.attributionInfo !== undefined) {
      ClipAttributionInfo.encode(message.attributionInfo, writer.uint32(82).fork()).ldelim();
    }
    if (message.recordedHeadphoneState !== 0) {
      writer.uint32(88).int32(message.recordedHeadphoneState);
    }
    if (message.remotePath !== "") {
      writer.uint32(98).string(message.remotePath);
    }
    if (message.originalURL !== "") {
      writer.uint32(106).string(message.originalURL);
    }
    if (message.externalProcessedId !== "") {
      writer.uint32(114).string(message.externalProcessedId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Clip {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClip();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.url = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 33) {
            break;
          }

          message.startTrim = reader.double();
          continue;
        case 5:
          if (tag !== 41) {
            break;
          }

          message.endTrim = reader.double();
          continue;
        case 6:
          if (tag !== 49) {
            break;
          }

          message.startOffset = reader.double();
          continue;
        case 7:
          if (tag !== 57) {
            break;
          }

          message.duration = reader.double();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.modifiers.push(ClipModifier.decode(reader, reader.uint32()));
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.name = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.attributionInfo = ClipAttributionInfo.decode(reader, reader.uint32());
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.recordedHeadphoneState = reader.int32() as any;
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.remotePath = reader.string();
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.originalURL = reader.string();
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.externalProcessedId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Clip {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      kind: isSet(object.kind) ? clip_KindFromJSON(object.kind) : 0,
      startTrim: isSet(object.startTrim) ? globalThis.Number(object.startTrim) : 0,
      endTrim: isSet(object.endTrim) ? globalThis.Number(object.endTrim) : 0,
      startOffset: isSet(object.startOffset) ? globalThis.Number(object.startOffset) : 0,
      duration: isSet(object.duration) ? globalThis.Number(object.duration) : 0,
      modifiers: globalThis.Array.isArray(object?.modifiers)
        ? object.modifiers.map((e: any) => ClipModifier.fromJSON(e))
        : [],
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      attributionInfo: isSet(object.attributionInfo) ? ClipAttributionInfo.fromJSON(object.attributionInfo) : undefined,
      recordedHeadphoneState: isSet(object.recordedHeadphoneState)
        ? headphoneStateFromJSON(object.recordedHeadphoneState)
        : 0,
      remotePath: isSet(object.remotePath) ? globalThis.String(object.remotePath) : "",
      originalURL: isSet(object.originalURL) ? globalThis.String(object.originalURL) : "",
      externalProcessedId: isSet(object.externalProcessedId) ? globalThis.String(object.externalProcessedId) : "",
    };
  },

  toJSON(message: Clip): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.kind !== 0) {
      obj.kind = clip_KindToJSON(message.kind);
    }
    if (message.startTrim !== 0) {
      obj.startTrim = message.startTrim;
    }
    if (message.endTrim !== 0) {
      obj.endTrim = message.endTrim;
    }
    if (message.startOffset !== 0) {
      obj.startOffset = message.startOffset;
    }
    if (message.duration !== 0) {
      obj.duration = message.duration;
    }
    if (message.modifiers?.length) {
      obj.modifiers = message.modifiers.map((e) => ClipModifier.toJSON(e));
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.attributionInfo !== undefined) {
      obj.attributionInfo = ClipAttributionInfo.toJSON(message.attributionInfo);
    }
    if (message.recordedHeadphoneState !== 0) {
      obj.recordedHeadphoneState = headphoneStateToJSON(message.recordedHeadphoneState);
    }
    if (message.remotePath !== "") {
      obj.remotePath = message.remotePath;
    }
    if (message.originalURL !== "") {
      obj.originalURL = message.originalURL;
    }
    if (message.externalProcessedId !== "") {
      obj.externalProcessedId = message.externalProcessedId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Clip>, I>>(base?: I): Clip {
    return Clip.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Clip>, I>>(object: I): Clip {
    const message = createBaseClip();
    message.id = object.id ?? "";
    message.url = object.url ?? "";
    message.kind = object.kind ?? 0;
    message.startTrim = object.startTrim ?? 0;
    message.endTrim = object.endTrim ?? 0;
    message.startOffset = object.startOffset ?? 0;
    message.duration = object.duration ?? 0;
    message.modifiers = object.modifiers?.map((e) => ClipModifier.fromPartial(e)) || [];
    message.name = object.name ?? "";
    message.attributionInfo = (object.attributionInfo !== undefined && object.attributionInfo !== null)
      ? ClipAttributionInfo.fromPartial(object.attributionInfo)
      : undefined;
    message.recordedHeadphoneState = object.recordedHeadphoneState ?? 0;
    message.remotePath = object.remotePath ?? "";
    message.originalURL = object.originalURL ?? "";
    message.externalProcessedId = object.externalProcessedId ?? "";
    return message;
  },
};

function createBaseClipAttributionInfo(): ClipAttributionInfo {
  return { creatorId: "", creatorType: 0, editorIds: [] };
}

export const ClipAttributionInfo = {
  encode(message: ClipAttributionInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.creatorId !== "") {
      writer.uint32(10).string(message.creatorId);
    }
    if (message.creatorType !== 0) {
      writer.uint32(16).int32(message.creatorType);
    }
    for (const v of message.editorIds) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ClipAttributionInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClipAttributionInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.creatorId = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.creatorType = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.editorIds.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClipAttributionInfo {
    return {
      creatorId: isSet(object.creatorId) ? globalThis.String(object.creatorId) : "",
      creatorType: isSet(object.creatorType) ? clipAttributionInfo_CreatorTypeFromJSON(object.creatorType) : 0,
      editorIds: globalThis.Array.isArray(object?.editorIds)
        ? object.editorIds.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ClipAttributionInfo): unknown {
    const obj: any = {};
    if (message.creatorId !== "") {
      obj.creatorId = message.creatorId;
    }
    if (message.creatorType !== 0) {
      obj.creatorType = clipAttributionInfo_CreatorTypeToJSON(message.creatorType);
    }
    if (message.editorIds?.length) {
      obj.editorIds = message.editorIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClipAttributionInfo>, I>>(base?: I): ClipAttributionInfo {
    return ClipAttributionInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClipAttributionInfo>, I>>(object: I): ClipAttributionInfo {
    const message = createBaseClipAttributionInfo();
    message.creatorId = object.creatorId ?? "";
    message.creatorType = object.creatorType ?? 0;
    message.editorIds = object.editorIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseClipModifier(): ClipModifier {
  return {
    voiceFx: undefined,
    vibe: undefined,
    volume: undefined,
    pitch: undefined,
    rate: undefined,
    denoised: undefined,
    pan: undefined,
  };
}

export const ClipModifier = {
  encode(message: ClipModifier, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.voiceFx !== undefined) {
      VoiceFx.encode(message.voiceFx, writer.uint32(10).fork()).ldelim();
    }
    if (message.vibe !== undefined) {
      writer.uint32(16).int32(message.vibe);
    }
    if (message.volume !== undefined) {
      writer.uint32(29).float(message.volume);
    }
    if (message.pitch !== undefined) {
      writer.uint32(37).float(message.pitch);
    }
    if (message.rate !== undefined) {
      writer.uint32(41).double(message.rate);
    }
    if (message.denoised !== undefined) {
      writer.uint32(48).bool(message.denoised);
    }
    if (message.pan !== undefined) {
      writer.uint32(61).float(message.pan);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ClipModifier {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClipModifier();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.voiceFx = VoiceFx.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.vibe = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.volume = reader.float();
          continue;
        case 4:
          if (tag !== 37) {
            break;
          }

          message.pitch = reader.float();
          continue;
        case 5:
          if (tag !== 41) {
            break;
          }

          message.rate = reader.double();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.denoised = reader.bool();
          continue;
        case 7:
          if (tag !== 61) {
            break;
          }

          message.pan = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClipModifier {
    return {
      voiceFx: isSet(object.voiceFx) ? VoiceFx.fromJSON(object.voiceFx) : undefined,
      vibe: isSet(object.vibe) ? vibeTypeFromJSON(object.vibe) : undefined,
      volume: isSet(object.volume) ? globalThis.Number(object.volume) : undefined,
      pitch: isSet(object.pitch) ? globalThis.Number(object.pitch) : undefined,
      rate: isSet(object.rate) ? globalThis.Number(object.rate) : undefined,
      denoised: isSet(object.denoised) ? globalThis.Boolean(object.denoised) : undefined,
      pan: isSet(object.pan) ? globalThis.Number(object.pan) : undefined,
    };
  },

  toJSON(message: ClipModifier): unknown {
    const obj: any = {};
    if (message.voiceFx !== undefined) {
      obj.voiceFx = VoiceFx.toJSON(message.voiceFx);
    }
    if (message.vibe !== undefined) {
      obj.vibe = vibeTypeToJSON(message.vibe);
    }
    if (message.volume !== undefined) {
      obj.volume = message.volume;
    }
    if (message.pitch !== undefined) {
      obj.pitch = message.pitch;
    }
    if (message.rate !== undefined) {
      obj.rate = message.rate;
    }
    if (message.denoised !== undefined) {
      obj.denoised = message.denoised;
    }
    if (message.pan !== undefined) {
      obj.pan = message.pan;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClipModifier>, I>>(base?: I): ClipModifier {
    return ClipModifier.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClipModifier>, I>>(object: I): ClipModifier {
    const message = createBaseClipModifier();
    message.voiceFx = (object.voiceFx !== undefined && object.voiceFx !== null)
      ? VoiceFx.fromPartial(object.voiceFx)
      : undefined;
    message.vibe = object.vibe ?? undefined;
    message.volume = object.volume ?? undefined;
    message.pitch = object.pitch ?? undefined;
    message.rate = object.rate ?? undefined;
    message.denoised = object.denoised ?? undefined;
    message.pan = object.pan ?? undefined;
    return message;
  },
};

function createBaseVoiceFx(): VoiceFx {
  return { type: 0, params: {}, intensity: 0 };
}

export const VoiceFx = {
  encode(message: VoiceFx, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    Object.entries(message.params).forEach(([key, value]) => {
      VoiceFx_ParamsEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).ldelim();
    });
    if (message.intensity !== 0) {
      writer.uint32(29).float(message.intensity);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VoiceFx {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceFx();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          const entry2 = VoiceFx_ParamsEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.params[entry2.key] = entry2.value;
          }
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.intensity = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceFx {
    return {
      type: isSet(object.type) ? voiceFx_VoiceFxTypeFromJSON(object.type) : 0,
      params: isObject(object.params)
        ? Object.entries(object.params).reduce<{ [key: string]: number }>((acc, [key, value]) => {
          acc[key] = Number(value);
          return acc;
        }, {})
        : {},
      intensity: isSet(object.intensity) ? globalThis.Number(object.intensity) : 0,
    };
  },

  toJSON(message: VoiceFx): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = voiceFx_VoiceFxTypeToJSON(message.type);
    }
    if (message.params) {
      const entries = Object.entries(message.params);
      if (entries.length > 0) {
        obj.params = {};
        entries.forEach(([k, v]) => {
          obj.params[k] = v;
        });
      }
    }
    if (message.intensity !== 0) {
      obj.intensity = message.intensity;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VoiceFx>, I>>(base?: I): VoiceFx {
    return VoiceFx.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VoiceFx>, I>>(object: I): VoiceFx {
    const message = createBaseVoiceFx();
    message.type = object.type ?? 0;
    message.params = Object.entries(object.params ?? {}).reduce<{ [key: string]: number }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = globalThis.Number(value);
      }
      return acc;
    }, {});
    message.intensity = object.intensity ?? 0;
    return message;
  },
};

function createBaseVoiceFx_ParamsEntry(): VoiceFx_ParamsEntry {
  return { key: "", value: 0 };
}

export const VoiceFx_ParamsEntry = {
  encode(message: VoiceFx_ParamsEntry, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VoiceFx_ParamsEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceFx_ParamsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceFx_ParamsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: VoiceFx_ParamsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VoiceFx_ParamsEntry>, I>>(base?: I): VoiceFx_ParamsEntry {
    return VoiceFx_ParamsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VoiceFx_ParamsEntry>, I>>(object: I): VoiceFx_ParamsEntry {
    const message = createBaseVoiceFx_ParamsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseVibeSettings(): VibeSettings {
  return { intensity: 0 };
}

export const VibeSettings = {
  encode(message: VibeSettings, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.intensity !== 0) {
      writer.uint32(13).float(message.intensity);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VibeSettings {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVibeSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.intensity = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VibeSettings {
    return { intensity: isSet(object.intensity) ? globalThis.Number(object.intensity) : 0 };
  },

  toJSON(message: VibeSettings): unknown {
    const obj: any = {};
    if (message.intensity !== 0) {
      obj.intensity = message.intensity;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VibeSettings>, I>>(base?: I): VibeSettings {
    return VibeSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VibeSettings>, I>>(object: I): VibeSettings {
    const message = createBaseVibeSettings();
    message.intensity = object.intensity ?? 0;
    return message;
  },
};

function createBaseSampler(): Sampler {
  return { id: "", samples: {} };
}

export const Sampler = {
  encode(message: Sampler, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    Object.entries(message.samples).forEach(([key, value]) => {
      Sampler_SamplesEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).ldelim();
    });
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Sampler {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSampler();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          const entry2 = Sampler_SamplesEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.samples[entry2.key] = entry2.value;
          }
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Sampler {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      samples: isObject(object.samples)
        ? Object.entries(object.samples).reduce<{ [key: string]: Sample }>((acc, [key, value]) => {
          acc[key] = Sample.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: Sampler): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.samples) {
      const entries = Object.entries(message.samples);
      if (entries.length > 0) {
        obj.samples = {};
        entries.forEach(([k, v]) => {
          obj.samples[k] = Sample.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Sampler>, I>>(base?: I): Sampler {
    return Sampler.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Sampler>, I>>(object: I): Sampler {
    const message = createBaseSampler();
    message.id = object.id ?? "";
    message.samples = Object.entries(object.samples ?? {}).reduce<{ [key: string]: Sample }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = Sample.fromPartial(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseSampler_SamplesEntry(): Sampler_SamplesEntry {
  return { key: "", value: undefined };
}

export const Sampler_SamplesEntry = {
  encode(message: Sampler_SamplesEntry, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      Sample.encode(message.value, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Sampler_SamplesEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSampler_SamplesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.value = Sample.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Sampler_SamplesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? Sample.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: Sampler_SamplesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = Sample.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Sampler_SamplesEntry>, I>>(base?: I): Sampler_SamplesEntry {
    return Sampler_SamplesEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Sampler_SamplesEntry>, I>>(object: I): Sampler_SamplesEntry {
    const message = createBaseSampler_SamplesEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? Sample.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseSample(): Sample {
  return { id: "", filePath: "", startTimeInFile: 0, duration: 0, remotePath: "", midiNote: 0 };
}

export const Sample = {
  encode(message: Sample, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.filePath !== "") {
      writer.uint32(18).string(message.filePath);
    }
    if (message.startTimeInFile !== 0) {
      writer.uint32(25).double(message.startTimeInFile);
    }
    if (message.duration !== 0) {
      writer.uint32(33).double(message.duration);
    }
    if (message.remotePath !== "") {
      writer.uint32(42).string(message.remotePath);
    }
    if (message.midiNote !== 0) {
      writer.uint32(48).int32(message.midiNote);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Sample {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSample();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.filePath = reader.string();
          continue;
        case 3:
          if (tag !== 25) {
            break;
          }

          message.startTimeInFile = reader.double();
          continue;
        case 4:
          if (tag !== 33) {
            break;
          }

          message.duration = reader.double();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.remotePath = reader.string();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.midiNote = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Sample {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      filePath: isSet(object.filePath) ? globalThis.String(object.filePath) : "",
      startTimeInFile: isSet(object.startTimeInFile) ? globalThis.Number(object.startTimeInFile) : 0,
      duration: isSet(object.duration) ? globalThis.Number(object.duration) : 0,
      remotePath: isSet(object.remotePath) ? globalThis.String(object.remotePath) : "",
      midiNote: isSet(object.midiNote) ? globalThis.Number(object.midiNote) : 0,
    };
  },

  toJSON(message: Sample): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.filePath !== "") {
      obj.filePath = message.filePath;
    }
    if (message.startTimeInFile !== 0) {
      obj.startTimeInFile = message.startTimeInFile;
    }
    if (message.duration !== 0) {
      obj.duration = message.duration;
    }
    if (message.remotePath !== "") {
      obj.remotePath = message.remotePath;
    }
    if (message.midiNote !== 0) {
      obj.midiNote = Math.round(message.midiNote);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Sample>, I>>(base?: I): Sample {
    return Sample.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Sample>, I>>(object: I): Sample {
    const message = createBaseSample();
    message.id = object.id ?? "";
    message.filePath = object.filePath ?? "";
    message.startTimeInFile = object.startTimeInFile ?? 0;
    message.duration = object.duration ?? 0;
    message.remotePath = object.remotePath ?? "";
    message.midiNote = object.midiNote ?? 0;
    return message;
  },
};

function createBaseKeyAndScale(): KeyAndScale {
  return { key: 0, scale: 0 };
}

export const KeyAndScale = {
  encode(message: KeyAndScale, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== 0) {
      writer.uint32(8).int32(message.key);
    }
    if (message.scale !== 0) {
      writer.uint32(16).int32(message.scale);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): KeyAndScale {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKeyAndScale();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.key = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.scale = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KeyAndScale {
    return {
      key: isSet(object.key) ? keyAndScale_KeyFromJSON(object.key) : 0,
      scale: isSet(object.scale) ? keyAndScale_ScaleFromJSON(object.scale) : 0,
    };
  },

  toJSON(message: KeyAndScale): unknown {
    const obj: any = {};
    if (message.key !== 0) {
      obj.key = keyAndScale_KeyToJSON(message.key);
    }
    if (message.scale !== 0) {
      obj.scale = keyAndScale_ScaleToJSON(message.scale);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KeyAndScale>, I>>(base?: I): KeyAndScale {
    return KeyAndScale.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KeyAndScale>, I>>(object: I): KeyAndScale {
    const message = createBaseKeyAndScale();
    message.key = object.key ?? 0;
    message.scale = object.scale ?? 0;
    return message;
  },
};

function createBaseEngineStats(): EngineStats {
  return { sessionLengthMilliseconds: 0, percentageSamplesClipped: 0, currentCPULoad: 0, currentRAMUsageGB: 0 };
}

export const EngineStats = {
  encode(message: EngineStats, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.sessionLengthMilliseconds !== 0) {
      writer.uint32(8).uint64(message.sessionLengthMilliseconds);
    }
    if (message.percentageSamplesClipped !== 0) {
      writer.uint32(29).float(message.percentageSamplesClipped);
    }
    if (message.currentCPULoad !== 0) {
      writer.uint32(37).float(message.currentCPULoad);
    }
    if (message.currentRAMUsageGB !== 0) {
      writer.uint32(45).float(message.currentRAMUsageGB);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EngineStats {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEngineStats();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.sessionLengthMilliseconds = longToNumber(reader.uint64() as Long);
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.percentageSamplesClipped = reader.float();
          continue;
        case 4:
          if (tag !== 37) {
            break;
          }

          message.currentCPULoad = reader.float();
          continue;
        case 5:
          if (tag !== 45) {
            break;
          }

          message.currentRAMUsageGB = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EngineStats {
    return {
      sessionLengthMilliseconds: isSet(object.sessionLengthMilliseconds)
        ? globalThis.Number(object.sessionLengthMilliseconds)
        : 0,
      percentageSamplesClipped: isSet(object.percentageSamplesClipped)
        ? globalThis.Number(object.percentageSamplesClipped)
        : 0,
      currentCPULoad: isSet(object.currentCPULoad) ? globalThis.Number(object.currentCPULoad) : 0,
      currentRAMUsageGB: isSet(object.currentRAMUsageGB) ? globalThis.Number(object.currentRAMUsageGB) : 0,
    };
  },

  toJSON(message: EngineStats): unknown {
    const obj: any = {};
    if (message.sessionLengthMilliseconds !== 0) {
      obj.sessionLengthMilliseconds = Math.round(message.sessionLengthMilliseconds);
    }
    if (message.percentageSamplesClipped !== 0) {
      obj.percentageSamplesClipped = message.percentageSamplesClipped;
    }
    if (message.currentCPULoad !== 0) {
      obj.currentCPULoad = message.currentCPULoad;
    }
    if (message.currentRAMUsageGB !== 0) {
      obj.currentRAMUsageGB = message.currentRAMUsageGB;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EngineStats>, I>>(base?: I): EngineStats {
    return EngineStats.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EngineStats>, I>>(object: I): EngineStats {
    const message = createBaseEngineStats();
    message.sessionLengthMilliseconds = object.sessionLengthMilliseconds ?? 0;
    message.percentageSamplesClipped = object.percentageSamplesClipped ?? 0;
    message.currentCPULoad = object.currentCPULoad ?? 0;
    message.currentRAMUsageGB = object.currentRAMUsageGB ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
